/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import TextFieldItemEdit from "./edit-item";

const TextFieldEdit = () => {
    return (
        <FieldListEditWrapper>
            <TextFieldItemEdit />
        </FieldListEditWrapper>
    );
};
TextFieldEdit.displayName = "TextFieldEdit";
export { TextFieldEdit };
